import { render, staticRenderFns } from "./LazyJobListItem.vue?vue&type=template&id=280ecbc9&scoped=true&"
import script from "./LazyJobListItem.vue?vue&type=script&lang=js&"
export * from "./LazyJobListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ecbc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VCard,VLazy,VSkeletonLoader})
